import { useCallback } from 'react';
import { useActivateEmissorContractAddressMutation, useCreateEmissorContractAddressMutation, useDeleteEmissorContractAddressMutation, } from '../services/contractAddressesApi';
export function useEmissorContractAddressActions() {
    const [triggerCreate, createState] = useCreateEmissorContractAddressMutation();
    const [triggerDelete, deleteState] = useDeleteEmissorContractAddressMutation();
    const [triggerActivate, activateState] = useActivateEmissorContractAddressMutation();
    const createAddress = useCallback(({ contractId, body }) => triggerCreate({ contractId, body }).unwrap(), [triggerCreate]);
    const deleteAddress = useCallback(({ contractId, addressId }) => triggerDelete({ contractId, addressId }).unwrap(), [triggerDelete]);
    const activateAddress = useCallback(({ contractId, addressId }) => triggerActivate({ contractId, addressId }).unwrap(), [triggerActivate]);
    return {
        createAddress,
        deleteAddress,
        activateAddress,
        isCreating: createState.isLoading,
        isDeleting: deleteState.isLoading,
        isActivating: activateState.isLoading,
    };
}
